<section class="usp-card">
  <app-icon [src]="imageLink" fontSize="5em"></app-icon>
  <p class="mat-display-1 title">{{title}}</p>
  <p class="mat-body-1 content">{{content}}</p>
</section>